import React, { useContext, useEffect, useState } from 'react'
import { CamelCaseWithSpaces, GetAllGroups, HideLoder, LogInSchoolID, LogInUserID, ShowLoder, formatDateToUsaMMDDYYYY, getAllUsers, getTypeWatchDelay, origin, transformNameOfCol, typewatch } from '../../JS/Common';
import { ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import HDrequestpopup from '../../Components/HDrequestpopup';
import AlertsComp from '../../Components/AlertsComp';
import CustomizationPopup from "../../Components/CustomizationPopup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faVideo } from '@fortawesome/free-solid-svg-icons';
import Pagination from 'react-js-pagination';
import Imagepopup from '../SupportTicket/Imagepopup';
import VideoPopup from '../SupportTicket/VideoPopup';
import HelpdeskCommentPopup from './HelpdeskCommentPopup';
import { CheckValidation } from '../../Components/Validations';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import Tab from '../../Components/Tab';
import PageHead from '../../Components/PageHead';
import AlertPopup from '../../Components/AlertPopup';
import DownloadOpenTicketReport from './DownloadOpenTicketReport';
import ImagesPopup from '../../Components/ImagesPopup';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import { useStickyAction } from '../../Hooks';

export default function Helpdeskrequest() {
    const { manager_user, staff_member } = useConfig();
    const { UserData } = useContext(UserContext);
    const StateData = useSelector((state) => state.authData);
    const [Loading, setLoading] = useState(false);
    const [isShow, setisShow] = useState(false);
    const [GridAllData, setGridAllData] = useState([]);
    const [PopupData, setPopupData] = useState('');
    const [Alerts, setAlerts] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [UserDetails, setUserDetails] = useState([])
    const [AllGroups, setAllGroups] = useState([])
    const [otherTicketsTabs, setOtherTicketsTabs] = useState({
        OpenTicketTabs: "active",
        CloseTicketTabs: "",
        searchForOpen: '',
        searchForClose: ''
    });
    const [columnNames, setColumnNames] = useState([]);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [PreviewVideo, SetPreviewVideo] = useState('')
    const [videoShow, setVideoShow] = useState(false);
    const [PreviewImg, SetPreviewImg] = useState('');
    const [lgShow, setLgShow] = useState(false);
    const [SortbyKey, setSortbyKey] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = GridAllData?.length > 0;
    const [allData, setAllData] = useState({
        UpdateFlag: 1,
        Title: "",
        Description: "",
        Id: 0,
        fileName: "",
        OriginalImage: "",
        ShowUploadDiv: "",
        ShowOriginalImage: "d-none",
        Flag: 0,
        TicketId: "",
        TicketNum: '',
        Comment: "",
        AssigneeId: '',
        Documentt: null,
        Filename: "",
        StatusFlag: '',
        SortbyFlag: 'asc'
    });
    const [IsCommentForHelpdesk, setIsCommentForHelpdesk] = useState(false);
    const [helpdeskId, setHelpdeskId] = useState('');
    const [deletePopup, setdeletePopup] = useState(false);
    const [ResolutionStatement, setResolutionStatement] = useState('');
    const [TrackedTime, setTrackedTime] = useState('');
    const [noteVisibility, setNoteVisibility] = useState({});
    const [filterassignedid, setFilterassignedid] = useState(null);
    const [showImagesModal, setShowImagesModal] = useState({
        show: false,
        activeIndex: 0,
        zoomInOut: false,
    });
    const SchoolAdminOnly = hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.ONLY_SCHOOL_ADMIN);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    const navigate = useNavigate();
    useEffect(() => {
        ApiGetHeaders(43, setColumnNames)
    }, []);
    useEffect(() => {
        if (otherTicketsTabs.OpenTicketTabs == 'active') {
            GetHelpdeskOtherRequests(1, otherTicketsTabs.searchForOpen ? otherTicketsTabs.searchForOpen : null, SortbyKey ? SortbyKey : null, false);
        } else {
            GetHelpdeskOtherRequests(2, otherTicketsTabs.searchForClose ? otherTicketsTabs.searchForClose : null, SortbyKey ? SortbyKey : null, false);
        }
    }, [currentPage, LimitForPagination, filterassignedid]);
    useEffect(() => {
        getAllUsers(setUserDetails);
        GetAllGroups({ setLoading, setAllGroups })
    }, [])
    async function GetHelpdeskOtherRequests(flag, searchstring, sortkey, toogleSort) {
        setNoteVisibility({});
        if (searchstring == "" || searchstring == undefined) {
            searchstring = null;
        }
        if (filterassignedid == 0) setFilterassignedid(null);
        if (sortkey != null && toogleSort) allData.SortbyFlag = allData.SortbyFlag == "asc" ? "desc" : "asc";
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/helpdesk/other-tickets?search=${searchstring}&schoolId=${LogInSchoolID}&userId=${LogInUserID}&sortBy=${sortkey}&sortByOrder=${allData.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&filter=${filterassignedid}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    if (responseRs?.status == "success") {
                        if (flag == 2) {
                            setpageRangeCount(responseRs?.close_tickets?.total);
                            setGridAllData(responseRs?.close_tickets?.data);
                        } else {
                            setpageRangeCount(responseRs?.open_tickets?.total);
                            setGridAllData(responseRs?.open_tickets?.data);
                        }
                    } else {
                        setGridAllData([])
                    }
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }

    async function UpdateLocation(Assignedid, flag, hdrequestid) {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            staffId: Assignedid == 0 ? null : Assignedid,
            flag: flag, //1 group 2 user
            hdRequestId: hdrequestid
        });
        await ApiPostCall("/helpdesk/assign-ticket", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Assigned Successfully"} />);
                    if (otherTicketsTabs.OpenTicketTabs == 'active') {
                        GetHelpdeskOtherRequests(1, otherTicketsTabs.searchForOpen ? otherTicketsTabs.searchForOpen : null, SortbyKey ? SortbyKey : null, false);
                    } else {
                        GetHelpdeskOtherRequests(2, otherTicketsTabs.searchForClose ? otherTicketsTabs.searchForClose : null, SortbyKey ? SortbyKey : null, false);
                    }
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    const handleSortClick = (item) => {
        const sortKey = item == "subject" ? "title" : item;
        if (sortKey) {
            const searchQuery = otherTicketsTabs.OpenTicketTabs == 'active'
                ? otherTicketsTabs.searchForOpen
                : otherTicketsTabs.searchForClose;
            const ticketStatus = otherTicketsTabs.OpenTicketTabs == 'active' ? 1 : 2;

            GetHelpdeskOtherRequests(ticketStatus, searchQuery, sortKey, true);
            setSortbyKey(sortKey);
        }
    };
    function GetCDNUrlForImage(finalpath) {
        ApiGetCDNData("/" + finalpath, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            setShowImagesModal({ ...showImagesModal, show: true, activeIndex: 0 })
            SetPreviewImg(url);
        });
    }
    function GetCDNUrlForVideo(finalpath) {
        ApiGetCDNData("/" + finalpath, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            setVideoShow(true);
            SetPreviewVideo(url);
        });
    }
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "document": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.document != null ? (
                <span>
                    <img src="/images/PicturePreview.svg"
                        className="boxshaowstyle cursor-pointer" height='25px'
                        onClick={(e) => { GetCDNUrlForImage(item.document); }} />
                </span>
            ) : '-'}</div>,
            "name": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.name || '-'}</div>,
            "type": <label style={{ color: "green" }}>{item?.type?.name}</label>,
            "email": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.email || '-'}</div>,
            "subject": <div className={`note-wrap ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.title || '-'}</div>,
            "building": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.building_name ? item.building_name : item?.building?.name}</div>,
            'description': <div className={`note-wrap ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item?.Description || '-'}</div>,
            'video': item.video != null ? (
                <span titleId={item.id}>
                    <FontAwesomeIcon
                        icon={faVideo}
                        style={{ height: '18px' }}
                        title="Video Attachment"
                        className="cursor-pointer"
                        onClick={(e) => {
                            GetCDNUrlForVideo(item.video);

                        }}
                    />
                </span>
            ) : '-',
            'room': <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.room_name ? item.room_name : item?.room ? item?.room?.name : '-'}</div>,
            'requester_type': <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.requester_type == 1 ? manager_user : staff_member}</div>,
            'student_no': <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.student_no == 'null' || item.student_no == null || item.student_no == '' ? '-' : item.student_no}</div>,
            'created_at': <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{formatDateToUsaMMDDYYYY(item.created_at) || '-'}</div>
        };

        return contentMap[columnName] || null;
    }

    async function ChangeStatus() {
        if (allData.StatusFlag == 1) {
            var isFormValid = CheckValidation({ formID: 'resolutionstatementdiv' });
            if (!isFormValid) return;
        }
        setLoading(true)
        var raw = JSON.stringify({
            hdRequestId: helpdeskId,
            flag: allData.StatusFlag,
            resolution: ResolutionStatement,
            trackedTime: TrackedTime
        });
        await ApiPostCall("/helpdesk/change-status", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    if (allData.StatusFlag == 1) {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"Ticket Close Successfully."} />);
                    } else {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"Ticket Open Successfully."} />);
                    }
                    setTimeout(() => {
                        setdeletePopup(false);
                        if (otherTicketsTabs.OpenTicketTabs == 'active') {
                            GetHelpdeskOtherRequests(1, null, null, false);
                        } else {
                            GetHelpdeskOtherRequests(2, null, null, false);
                        }
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                }
            }
        });
    }
    function GenerateUrl(hdId, ticketNum) {
        var schoolnumber = StateData?.Schoolnumber;
        var path = `/helpdesk-ticket/${hdId}/${schoolnumber}/${ticketNum}`;
        var baseurl = origin;
        var url = `${baseurl}${path}`;
        const newTab = window.open('', '_blank');
        newTab.location.href = url;
        newTab.focus();
    }
    function handleArrowClick(hid) {
        setNoteVisibility((prevState) => ({
            ...prevState,
            [hid]: !prevState[hid],
        }));
    }
    async function GetHelpdeskDataById(reuqestid) {
        setLoading(true);
        await ApiGetCallAuthKey(`/helpdesk?schoolId=${LogInSchoolID}&uuid=${reuqestid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setPopupData(responseRs);
                setisShow(true);
                setLoading(false);
            }
        });
    }
    function handleTabClick(tabType) {
        if (tabType == "open") {
            GetHelpdeskOtherRequests(1, null, null, false);
            setOtherTicketsTabs({ ...otherTicketsTabs, OpenTicketTabs: "active", CloseTicketTabs: "", searchForOpen: '' });
            setCurrentPage(1);
            setNoteVisibility({})
        } else if (tabType == "close") {
            GetHelpdeskOtherRequests(2, null, null, false);
            setOtherTicketsTabs({ ...otherTicketsTabs, OpenTicketTabs: "", CloseTicketTabs: "active", searchForClose: '' });
            setCurrentPage(1);
            setNoteVisibility({})
        }
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        GetHelpdeskOtherRequests(otherTicketsTabs.OpenTicketTabs == 'active' ? 1 : 2, e.target.value, null, false);
        otherTicketsTabs.OpenTicketTabs == 'active' ?
            setOtherTicketsTabs({ ...otherTicketsTabs, searchForOpen: e.target.value }) :
            setOtherTicketsTabs({ ...otherTicketsTabs, searchForClose: e.target.value })
    }
    return (
        <>
            {Loading ? <ShowLoder /> : <HideLoder />}
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Other Help Desk Requests"} handleSearch={handleSearchChange}
                loading={Loading} Alerts={Alerts} showsearch={true} />
            <div className='row my-2 d-flex justify-content-between pe-0 align-items-center'>
                <div className='col-md-12 ps-0 text-center d-md-flex justify-content-end align-items-center'>
                    {SchoolAdminOnly && (
                        <label className="font-14 pe-3" style={{ color: 'black', cursor: 'pointer' }} onClick={(e) => navigate("/helpdesk-ticket-assignments")}><u> Help Desk Assignments</u></label>
                    )}
                    <DownloadOpenTicketReport setAlerts={setAlerts} />
                </div>
            </div>
            <div className="GridBox p-3 mt-2">
                <div className="row align-items-center mb-3">
                    <div className="col-md-9 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={otherTicketsTabs.OpenTicketTabs == 'active'}
                                label="Open Tickets" onClick={() => handleTabClick('open')} col={'col-md-3'} />
                            <Tab isActive={otherTicketsTabs.CloseTicketTabs == 'active'}
                                label="Closed Ticket" onClick={() => handleTabClick('close')} col={'col-md-3'} />
                        </ul>
                    </div>

                    <div className="col-md-3 text-end">
                        <select className="mb-1 px-0" onChange={(e) => { setFilterassignedid(e.target.value); }}>
                            <option value="0">Filter by Assigned To</option>
                            {UserDetails.map((item1, j) => (
                                <option value={item1.id} key={j} data-type="AssigneeId">
                                    {item1.name}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600 cursor-pointer' title='Sort by Ticket #' onClick={(e) => handleSortClick('request_num')}>Ticket #
                                        <img src="/images/sortbynew.svg" alt={`Sort by Ticket #`} className="img-fluid ps-2 sortbyClass" />

                                    </th>
                                    {columnNames?.map((item) => {
                                        let columnName = item.replace(/_/g, ' ');
                                        const transformedName = columnName == "student no" ? "User ID" : transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            item != "video" && item != 'document' && item != 'type' && item != "room" && item != "building" ?
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                                :
                                                <th key={item} scope="col" className='fw-600'>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                </th>
                                        );
                                    })}
                                    {otherTicketsTabs.OpenTicketTabs == 'active' && (
                                        <th scope="col" className='cursor-pointer fw-600'>Assigned To </th>)}
                                    <th scope="col" className={`cursor-pointer fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                        Action
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5"
                                            title='Customize Headers' style={{ height: '25px' }}
                                            onClick={(e) => setCustomizationModal(true)} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {GridAllData?.length != 0 ?
                                    GridAllData?.map((item, i) => {
                                        const isNoteVisible = noteVisibility[item.id];
                                        var returnData = (
                                            <tr key={i} className="OddEvenClass tableBorderHide">
                                                <td className="py-12">
                                                    <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.request_num || '-'} </div></td>
                                                {columnNames?.map(header => (
                                                    <td className="py-12" key={header}>  {renderContentForColumn(header, item)} </td>
                                                ))}
                                                {otherTicketsTabs.OpenTicketTabs == 'active' && (
                                                    <td className="col-md-3 hoverable-text" onMouseEnter={(e) => { setIsDropdownOpen(i); }} onMouseLeave={() => setIsDropdownOpen(null)}>
                                                        {item.assigned_flag == 2 ?
                                                            <>
                                                                {isDropdownOpen === i ? (
                                                                    <select className="px-0" defaultValue={item.assigned_to_id} onChange={(e) => {
                                                                        const selectedValue = e.target.value;
                                                                        const selectedOption = e.target.options[e.target.selectedIndex];
                                                                        const flag = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                        UpdateLocation(selectedValue, flag, item.id);
                                                                    }}>
                                                                        <option value="0">Select</option>
                                                                        {UserDetails.map((item1, j) => (
                                                                            <option value={item1.id} key={j} data-type="AssigneeId" defaultValue={item1.id == item.assigned_to_id} >
                                                                                {item1.name}
                                                                            </option>
                                                                        ))}
                                                                        {AllGroups.map((item2, k) => (
                                                                            <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups" >
                                                                                {item2.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item?.user?.first_name + ' ' + item?.user?.last_name}</div>
                                                                )}

                                                            </>
                                                            : item.assigned_flag == 1 ?
                                                                <>
                                                                    {isDropdownOpen === i ? (
                                                                        <select className="px-0" defaultValue={item.assigned_to_id} onChange={(e) => {
                                                                            const selectedValue = e.target.value;
                                                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                                                            const flag = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                            UpdateLocation(selectedValue, flag, item.id);
                                                                        }}>
                                                                            <option value="0">Select</option>
                                                                            {UserDetails.map((item1, j) => (
                                                                                <option value={item1.id} key={j} data-type="AssigneeId">
                                                                                    {item1.name}
                                                                                </option>
                                                                            ))}
                                                                            {AllGroups.map((item2, k) => (
                                                                                <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups" defaultValue={item2.id == item.assigned_to_id}>
                                                                                    {item2.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : (
                                                                        <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item?.usergroup?.name}</div>
                                                                    )}

                                                                </>

                                                                :
                                                                <>
                                                                    {isDropdownOpen === i ? (
                                                                        <select className="px-0" onChange={(e) => {
                                                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                                                            const source = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                            UpdateLocation(e.target.value, source, item.id);
                                                                        }}>
                                                                            <option value="0">Select</option>
                                                                            {UserDetails.map((item1, j) => (
                                                                                <option value={item1.id} key={j} data-type="AssigneeId">
                                                                                    {item1.name}
                                                                                </option>
                                                                            ))}
                                                                            {AllGroups.map((item2, k) => (
                                                                                <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups">
                                                                                    {item2.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : (
                                                                        <div className="py-2">-</div>
                                                                    )}
                                                                </>
                                                        }
                                                    </td>
                                                )}
                                                <td className={`py-12 d-flex ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    <img src="/images/previewpdficon.svg" className="cursor-pointer px-1" title='Preview Help Desk Tickets' titleid={item.id} onClick={(e) => GenerateUrl(item.id, item.request_num)} height='18px' />
                                                    <img src='/images/InfoIcon.svg' className='img-fluid px-1 cursor-pointer' title='Show Help Desk Request' style={{ height: "16px" }} onClick={(e) => GetHelpdeskDataById(item.id)} />

                                                    {item.assigned_user_flag == 1 || SchoolAdminOnly ?
                                                        otherTicketsTabs.OpenTicketTabs == 'active' ?
                                                            <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as closed" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, StatusFlag: 1 }); setHelpdeskId(item.id) }} height='18px' />
                                                            :
                                                            <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as Open" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, StatusFlag: 2 }); setHelpdeskId(item.id) }} height='18px' />
                                                        : <></>
                                                    }
                                                    {item.assigned_user_flag == 1 || SchoolAdminOnly ?
                                                        otherTicketsTabs.OpenTicketTabs == 'active' && (
                                                            <FontAwesomeIcon icon={faComment} style={{ color: "black", height: "18px" }} className='cursor-pointer px-1' onClick={(e) => { setHelpdeskId(item.id); setIsCommentForHelpdesk(true); }} title="Comment" />
                                                        )
                                                        : <></>
                                                    }
                                                    {item.status == 2 && (
                                                        <>
                                                            <img src="/images/DownRoundArrow.svg" title="Show Resolution Statement" className={`cursor-pointer px-1 img-fluid ${isNoteVisible ? "d-none" : ""}`} onClick={() => handleArrowClick(item.id)} height='18px' />
                                                            <img src="/images/UpRoundArrow.svg" title="Hide Resolution Statement" className={`img-fluid px-1 cursor-pointer ${isNoteVisible ? "" : "d-none"}`} onClick={() => handleArrowClick(item.id)} height='18px' />
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                        if (isNoteVisible) {
                                            returnData = (
                                                <>
                                                    {returnData}
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Resolution Statement:</b>
                                                            <div style={{ display: "inline" }}> {item.resolution || '-'} </div>
                                                        </td>
                                                    </tr>
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Open Date:</b>
                                                            <div style={{ display: "inline" }}> {item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'} </div>
                                                        </td>
                                                    </tr>
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Completion Time:</b>
                                                            <div style={{ display: "inline" }}> {item.completion_time ? item.completion_time + ` hours` : '-'} </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                        return returnData;
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={16}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {showPagination && (
                        <Pagination
                            activePage={currentPage}
                            totalItemsCount={pageRangeCount}
                            pageRangeDisplayed={15}
                            itemsCountPerPage={LimitForPagination}
                            onChange={(e) => setCurrentPage(e)}
                            color="primary"
                            lastPageText=""
                            firstPageText=""
                            itemClassFirst="MasterClass"
                            itemClassPrev="MasterClass"
                            itemClassNext="MasterClass"
                            itemClassLast="MasterClass"
                            hideFirstLastPages={true}
                        />
                    )}
                </div>
            </div>
            <HDrequestpopup isShow={isShow} closepopup={(e) => setisShow(false)} PopupData={PopupData} />
            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Other Help Desk Tickets'} GetCall={() => ApiGetHeaders(43, setColumnNames)} />
            )}
            {lgShow == true && (
                <Imagepopup lgShow={lgShow} setLgShow={setLgShow} PreviewImg={PreviewImg} />
            )}
            {videoShow == true && (
                <VideoPopup videoShow={videoShow} setVideoShow={setVideoShow} PreviewVideo={PreviewVideo} />
            )}

            {IsCommentForHelpdesk == true && (
                <HelpdeskCommentPopup IsComment={IsCommentForHelpdesk} setIsComment={(e) => setIsCommentForHelpdesk(false)}
                    setAllData={setAllData} allData={allData} setLoading={setLoading}
                    GetAllSupportTickets={(e) => GetHelpdeskOtherRequests(1, null, null, false)} setAlerts={setAlerts} helpdeskId={helpdeskId} />
            )}
            <AlertPopup isshow={deletePopup} img={allData.StatusFlag == 1 ? '/images/redInfo.svg' : '/images/greenInfo.svg'}
                headingtext={allData.StatusFlag == 1 ? 'Are you sure want to close ticket?' : 'Are you sure want to Open ticket?'}
                text={allData.StatusFlag == 1 && (
                    <div className="col-12 parent pt-2 px-4" id="resolutionstatementdiv">
                        <div className="col-12">
                            <textarea type="textarea" rows={2} autoComplete="off" required name="resolution" className="form-control" onChange={(e) => setResolutionStatement(e.target.value)} />
                            <div className='FormLabel'>What did you do to resolve the issue?<label className='redText'>*</label></div>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                        <div className="col-12 pt-4">
                            <input type="number" className="form-control" autoComplete='off'
                                name="timetrack" min={0} max={999}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let value = parseInt(e.target.value, 10);
                                    if (isNaN(value)) value = 0;
                                    value = Math.max(0, Math.min(999, value));
                                    setTrackedTime(value);
                                }} required />
                            <div className='FormLabel'>How many hours did you spend to resolve this ticket?<label className='redText'>*</label></div>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                )}
                cancelcall={(e) => { setResolutionStatement(""); setdeletePopup(false); setAllData({ ...allData, TicketId: "" }) }}
                canceltext={"Cancel"} successtext={"Yes"} successcall={(e) => ChangeStatus(e)} btntype={allData.StatusFlag == 1 ? 'deleteBtn' : 'SaveBtn'} />

            <ImagesPopup
                AllImages={[PreviewImg]}
                isShow={showImagesModal.show}
                closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
                title={"Preview Images"}
                size={"xl"}
                activeIndex={showImagesModal.activeIndex}
                handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
                zoomInOut={showImagesModal.zoomInOut}
                handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
            />
        </>
    )
}
